import { gql } from '@apollo/client';
import { CONSENTS_GROUP_FIELDS } from '@isyc-react/oc-api/fragments';
import { MATCH_ANY_PARAMETERS } from 'wildcard-mock-link';
import { setConsentsGroupStatus } from './data';
const CONSENTS_GROUP_UPDATE_STATUS = gql `
  ${CONSENTS_GROUP_FIELDS}
  mutation consentsGroupUpdateStatus($id: Long, $status: EmbededTreeDtoInput) {
    consentsGroup_updateStatus(id: $id, status: $status) {
      ...ConsentsGroupFields
    }
  }
`;
export default [
    {
        request: {
            query: CONSENTS_GROUP_UPDATE_STATUS,
            variables: MATCH_ANY_PARAMETERS,
        },
        result: (variables) => {
            let id = variables === null || variables === void 0 ? void 0 : variables.id;
            let status = variables === null || variables === void 0 ? void 0 : variables.status;
            const consentsGroup = setConsentsGroupStatus(id, status);
            return {
                data: {
                    consentsGroup_updateStatus: consentsGroup,
                },
            };
        },
    },
];
